import { formaterDate } from '../lib/format.js';

const LIBELLES_CATEGORIE = {
  visite: 'Visite',
  repas: 'Repas',
  transport: 'Transport',
  hebergement: 'Hébergement',
  loisir: 'Loisir',
  autre: 'Autre',
};

/**
 * Le séjour d'un seul tenant, journée après journée.
 *
 * La vue par jour sert à travailler une journée ; celle-ci sert à voir le
 * rythme d'ensemble — où sont les journées chargées, où sont les trous, si le
 * dernier jour est bien allégé. C'est une lecture, pas un écran d'édition :
 * aucune action n'y figure, on repasse en vue par jour pour modifier.
 */
export function Chronologie({ itineraire }) {
  const jours = itineraire.days ?? [];
  if (jours.length === 0) return null;

  // Une journée bien remplie sert d'échelle : les autres se comparent à elle.
  const maximum = Math.max(1, ...jours.map((j) => j.items.length));

  return (
    <div className="chronologie">
      {jours.map((jour) => (
        <section key={jour.dayIndex} className="chrono-jour">
          <header className="chrono-jour__entete">
            <span className="chrono-jour__numero">Jour {jour.dayIndex}</span>
            {jour.date && (
              <span className="chrono-jour__date">{formaterDate(jour.date)}</span>
            )}
            <span className="chrono-jour__compte">
              {jour.items.length === 0
                ? 'rien de prévu'
                : `${jour.items.length} étape${jour.items.length > 1 ? 's' : ''}`}
            </span>
            {/* Barre de charge : le rythme du séjour se lit d'un coup d'œil,
                sans compter les lignes. */}
            <span className="chrono-jour__charge" aria-hidden="true">
              <span style={{ width: `${(jour.items.length / maximum) * 100}%` }} />
            </span>
          </header>

          {jour.items.length > 0 && (
            <ol className="chrono-etapes">
              {jour.items.map((item) => (
                <li key={item.id} className={`chrono-etape categorie--${item.category}`}>
                  <span className="chrono-etape__heure">{item.time ?? '—'}</span>
                  <span className="chrono-etape__titre">{item.title}</span>
                  <span className="chrono-etape__categorie">
                    {LIBELLES_CATEGORIE[item.category] ?? item.category}
                  </span>
                </li>
              ))}
            </ol>
          )}
        </section>
      ))}
    </div>
  );
}
